import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import info_icon from "../../assets/images/info_icon.svg";

const InfoPopover = ({
    title,
    items = [],
    placement = "top",
    labelKey = "name",
    valueKey = "amount",
    formatter = (v) => `$${v.toFixed(2)}`
}) => {
    const hasData = items && items.length > 0;

    const popover = (
        <Popover className="payroll_popover">
            <Popover.Header as="h6">{title}</Popover.Header>
            <Popover.Body>
                {hasData ? (
                    items.map((item, index) => (
                        <div
                            key={index}
                            className="d-flex justify-content-between mb-1"
                        >
                            <span>{item[labelKey]}</span>
                            <strong>{formatter(item[valueKey])}</strong>
                        </div>
                    ))
                ) : (
                    <div className="text-muted text-center">
                        No details available
                    </div>
                )}
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger={hasData ? "click" : []}
            placement={placement}
            overlay={popover}
            rootClose
        >
            <img
                src={info_icon}
                alt="info"
                className={`ml_10 cursor_pointer ${!hasData ? "opacity_50" : ""
                    }`}
            />
        </OverlayTrigger>
    );
};


export default InfoPopover;
